import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useSelector } from "react-redux";
import { openApp } from "../../utils/function";
// Reusable styles for components
const cardStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "370px",
    height: "auto",
    padding: "16px",
    borderRadius: "16px",
    backgroundColor: "#FFF",
    boxShadow: "0px 0px 24px 0px rgba(0, 92, 188, 0.08)",
    flexShrink: 0,
    justifyContent: "space-between",
  },
  image: {
    width: "100%",
    height: "198px",
    borderRadius: "4px",
    objectFit: "cover",
  },
  textSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexGrow: 1,
    gap: "16px",
  },
  title: {
    color: "#27251F",
    fontFamily: "Inter, sans-serif",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  button: {
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "24px",
    backgroundColor: "#005CBC",
    alignSelf: "stretch",
  },
  buttonText: {
    color: "#FFF",
    fontFamily: "Inter, sans-serif",
    fontSize: "16px",
    fontWeight: 700,
  },
};

// CardItem component
export default function CardItem({ image, title, appUrl, token, appName }) {
  const navigate = useNavigate();
  const { External } = useSelector((store) => store.config); // Get the authentication state

  return (
    <Box sx={cardStyles.container}>
      {/* Image */}
      <Box component="img" src={image} alt={title} sx={cardStyles.image} />

      {/* Text Section */}
      <Box sx={cardStyles.textSection}>
        <Box>
          <Typography sx={cardStyles.title} variant="h4">
            {title}
          </Typography>
        </Box>

        {/* Button with centered text and icon */}
        <Button
          sx={cardStyles.button}
          onClick={() => openApp(token, appName, appUrl, External, navigate)}
          endIcon={
            <ArrowForwardIcon sx={{ fontSize: "20px", color: "white" }} />
          }
        >
          <Typography sx={cardStyles.buttonText}>Open App</Typography>
        </Button>
      </Box>
    </Box>
  );
}
